import { ToolRoute } from '../constants/routes';

export const Features = {
  MATTERS: 'MATTERS',
  RAF_EXTRACT: 'RAF_EXTRACT',
} as const;

export type FeatureName = typeof Features[keyof typeof Features];

export const toFeatureName = (value: unknown): FeatureName | undefined => {
  if (typeof value !== 'string') return undefined;
  const upper = value.toUpperCase();
  return (Object.values(Features) as string[]).includes(upper) ? (upper as FeatureName) : undefined;
};

export const ROUTE_FEATURE_MAP: Record<string, FeatureName> = {
  [ToolRoute.MATTERS]: Features.MATTERS,
};
